<template>
  <Modal>
    <Modal.Title>Change password</Modal.Title>
    <Modal.Body>
      <div class="flex flex-col gap-4">
        <Input
          v-model="currentPassword"
          type="password"
          label="Current password"
          size="xl"
          :disabled="loading"
          :error="currentPasswordError"
        />
        <Input
          v-model="newPassword"
          type="password"
          label="New password"
          size="xl"
          :disabled="loading"
        />
        <Input
          v-model="confirmPassword"
          type="password"
          label="Confirm new password"
          size="xl"
          :disabled="loading"
          :error="confirmPasswordError"
        />
      </div>
    </Modal.Body>
    <Modal.Footer>
      <template #left>
        <button
          type="button"
          class="text-link"
          :class="{ 'pointer-events-none': loading }"
          @click="handleForgot"
        >
          Forgot password?
        </button>
      </template>
      <Button variant="stroke" :disabled="loading" @click="close()">
        Cancel
      </Button>
      <Button
        variant="primary"
        :disabled="!canSave"
        :loading="loading"
        @click="handleSave"
      >
        Change password
      </Button>
    </Modal.Footer>
  </Modal>
</template>

<script setup lang="ts">
import { Modal, Input, Button, useModal } from '@dacr/library'

import { useChangePassword } from './useChangePassword'

const { close } = useModal()

const {
  currentPassword,
  newPassword,
  confirmPassword,
  currentPasswordError,
  confirmPasswordError,
  loading,
  canSave,
  save,
  forgotPassword,
} = useChangePassword()

const handleSave = async () => {
  if (await save()) close()
}

const handleForgot = async () => {
  await forgotPassword()
  close()
}
</script>
